import axiosService from '../axios.service';

const signupsDataService = {

  add(signUp) {
    return new Promise((resolve) => {

      axiosService.api.post(`/signUps`, signUp)
        .then(response => {
          resolve(response);
        })
    })
  },
}

export default signupsDataService
